// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-cart-checkout__messages',
    // #endregion
    // #region Events
    emits: ["command"],
    // #endregion
    // #region Properties
    props: {
        cart: {
            type: Object,
            required: false,
            default: {}
        },
        schema: {
            type: Object,
            required: false,
            default: {}
        },
        data: {
            type: Object,
            required: false,
            default: {}
        },
        status: {
            type: Object,
            required: true,
            default: {}
        }
    },
    // #endregion
    // #region Methods
    methods: {
        cmdRemoveMessage(message) {
            // #region Api
            host.api.delete(`commerce/checkout/${this.cart.cartID}/messages/${message.id}`);
            // #endregion
            // #region Remove
            this.status.messages.splice(this.status.messages.indexOf(message));
            // #endregion
        },
    }
    // #endregion
});
// #endregion
